module.exports = {"330703001":"多湖街道","330703002":"东孝街道","330703101":"孝顺镇","330703102":"傅村镇","330703103":"曹宅镇","330703104":"澧浦镇","330703105":"岭下镇","330703106":"江东镇","330703107":"塘雅镇","330703108":"赤松镇","330703200":"源东乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330703.json
// module id = 998
// module chunks = 0